var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-placeholder"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"products-placeholder__heading"}),_c('div',{staticClass:"products-row row"},_vm._l((5),function(index){return _c('div',{key:index,staticClass:"product-column col-xs-12 col-sm-6 col-lg-4"},[_c('div',{staticClass:"product-placeholder"})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }